const initialState = { adminRoles: [], adminInfo: {}, userInfoDetailsAdmin: [] }
const resetState = {}

export default function (state = initialState, action) {
    const { type, payload1, payload2 } = action;

    switch (type) {
        case "ADMIN_DETAILS":
            return { ...state, adminRoles: payload1, adminInfo: payload2 };
        case "USERINFO_DETAILS_ADMIN":
            return { ...state, userInfoDetailsAdmin: payload1 };
        case "DASH_TABLE_INFO_DETAILS":
            return { ...state, dashboardTableDetails: payload1 };
        case "DASH_ORDER_GRAPH_DETAILS":
            return { ...state, dashboardOrderGraphDetails: payload1 };
        case "DASH_SUB_GRAPH_DETAILS":
            return { ...state, dashboardSubscriptionGraphDetails: payload1 };
        case "USER_MANAGEMENT_CUSTOMER_DETAILS":
            return { ...state, userManagemntCustomerDetails: payload1 };
        case "USER_MANAGEMENT_ADMIN_DETAILS":
            return { ...state, userManagemntAdminDetails: payload1 };
        case "ADMIN_LOGOUT":
            return { resetState };
        default:
            return state;
    }
}
